import { EVENT_SOURCE } from '../../constants/analytics';
import { type ApplicationModes } from '../../constants/application-modes';

import { sha256Hash } from './sha256-hash';

interface AdvancedSearchDwelledProps {
	dwellData: any;
	searchSessionId: string;
	searchQuery: string;
	applicationMode: ApplicationModes;
}

// Is enhanced with dwell metrics in the parent by a DwellTimeHelper
export const onAdvancedSearchDwelled = ({
	dwellData,
	searchSessionId,
	searchQuery,
	applicationMode,
}: AdvancedSearchDwelledProps): any => {
	const queryHash = sha256Hash(searchQuery);
	return {
		...dwellData,
		source: EVENT_SOURCE,
		actionSubject: 'searchPage',
		attributes: {
			additionalAttributes: {
				...dwellData.attributes,
				searchSessionId,
				queryHash,
				mode: applicationMode,
			},
		},
		eventType: 'track',
	};
};
